import { Icon, Spinner, colorValue, OverlayTrigger } from '@hai/ui-react';
import React from 'react';
import { ConditionalWrapper } from './form/conditional-wrapper';
import { constant } from 'src/js/constant';

interface Busy {
  busy: boolean;
  disabled?: boolean;
  isActive: boolean;
  activeIcon: string;
  inactiveIcon: string;
  tooltipActive?: string;
  tooltipInactive?: string;
}

const BusyIcon: React.FunctionComponent<Busy> = ({
  busy,
  isActive,
  activeIcon,
  inactiveIcon,
  disabled,
  tooltipActive,
  tooltipInactive,
}: Busy) => {
  return busy ? (
    <Spinner loopTime={1} {...{ style: { width: '18px', height: '18px', margin: '0px 3px 0px 3px' } }} />
  ) : (
    <ConditionalWrapper
      condition={(tooltipActive && isActive) || (tooltipInactive && !isActive)}
      wrapper={(children) => (
        <OverlayTrigger
          //    popoverContent={<div className="properTooltip">{tooltipActive && isActive ? tooltipActive : tooltipInactive}</div>}
          popoverContent={tooltipActive && isActive ? tooltipActive : tooltipInactive}
          popoverBgColor={constant.productColor}
          popoverTextColor={'haiui-white'}
          placement="top"
          delay={400}
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <Icon
        iconname={isActive ? activeIcon : inactiveIcon}
        color={colorValue('haiui-gray-04')}
        className={`mk-busy-icon${disabled && ' disabled'}`}
        tooltip={isActive ? tooltipActive : tooltipInactive}
      />
    </ConditionalWrapper>
  );
};

export default BusyIcon;
